<mat-drawer-container>
  <mat-drawer-content>
    <div class="application-content" fxLayout="column" [fxHide]="!reportConfigured">
      <div fxLayout="row" fxLayoutAlign="space-between start">
        <div fxLayout="column">
          <div fxFlex>
            <a class="breadcrumbs" (click)="backToCredentialing()"
              ><span class="breadcrumbs-icon"><mat-icon>arrow_back</mat-icon></span>
              <span class="breadcrumbs-text">Back to Credentialing</span></a
            >
            <h1 class="report-header">{{ title }}</h1>
          </div>
        </div>
        <div fxFlex fxLayoutAlign="end start">
          <button class="mat-raised-button" mat-button color="primary" [matMenuTriggerFor]="menu">
            Action <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item appThrottleClick [disabled]="totalResultCount == 0" (click)="export()">Export</button>
          </mat-menu>
        </div>
      </div>
      <odata-filter
        #filterComponent
        [filterMenuOption]="{
          viewMenuTitle: title,
          readOnlyViewMenu: false,
          hideViewMenuSearchBar: true,
          hideManageColumns: true,
          searchPlaceHolder: 'Search by name or email',
          filterService: filterService,
          viewContextId: viewContextId,
        }"
        (selectView)="selectView($event)"
        (createView)="sideBar.create()"
        (editView)="sideBar.edit($event)"
      ></odata-filter>
      <div fxLayout="row" fxLayoutAlign="end center" fxFlex>
        <app-paginator [filterService]="filterService"> </app-paginator>
      </div>
      <div *ngIf="isFetchingData" class="waiting-spinner">
        <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
        <p>Loading...</p>
      </div>
      <div class="no-results" *ngIf="totalResultCount == 0">
        <h3>No results found.</h3>
        <p>Try removing some search filters (or maybe all of them!)</p>
      </div>
      <ng-scrollbar [track]="'all'">
        <mat-table
          #table
          [dataSource]="dataSource"
          matSort
          [matSortActive]="sortColumnName"
          [matSortDirection]="orderDirection"
          (matSortChange)="onSortChange($event)"
          *ngIf="selectedView && report.length && !isFetchingData"
        >
          <ng-container *ngFor="let column of customViewColumns" [matColumnDef]="column.columnDefinition">
            <div *ngIf="!column.isCustomField">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.displayName }}</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div
                  *ngIf="
                    column.systemName == 'credentialApplicationStartDate' ||
                    column.systemName == 'credentialApplicationEndDate' ||
                    column.systemName == 'credentialApplicationUpdatedOn'
                  "
                >
                  {{ element[column.systemName] | localDate: 'MMM DD, YYYY' }}
                </div>

                <div
                  *ngIf="
                    column.systemName != 'credentialApplicationStartDate' &&
                    column.systemName != 'credentialApplicationEndDate' &&
                    column.systemName != 'credentialApplicationUpdatedOn'
                  "
                >
                  {{ element[column.systemName] }}
                </div>
              </mat-cell>
            </div>
            <div *ngIf="column.isCustomField">
              <mat-header-cell
                *matHeaderCellDef
                [matTooltip]="column.displayName"
                matTooltipShowDelay="500"
                matTooltipPosition="left"
              >
                <span class="truncate-text">{{ column.displayName }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{
                getDynamicScenarioColumnValue(column.customFieldId, element)
              }}</mat-cell>
            </div>
          </ng-container>

          <ng-container matColumnDef="contextMenu" sticky>
            <mat-header-cell class="context-menu" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="context-menu" *matCellDef="let element">
              <div fxFlex fxLayoutAlign="center center">
                <mat-checkbox
                  color="primary"
                  [(ngModel)]="element.selected"
                  (click)="$event.stopPropagation()"
                ></mat-checkbox>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" (click)="openSideBar(row)"></mat-row>
        </mat-table>
      </ng-scrollbar>
    </div>
  </mat-drawer-content>
  <mat-drawer class="drawer" [disableClose]="true" mode="over" position="end" #drawer [opened]="isDrawerOpen">
    <lineup-views-sidebar
      [title]="'Credential Application View'"
      [filterService]="filterService"
      [viewContextId]="viewContextId"
      (close)="drawer.close()"
      (open)="drawer.open()"
      #sideBar
    ></lineup-views-sidebar>
    <router-outlet></router-outlet>
  </mat-drawer>
</mat-drawer-container>
